import React from 'react';
import { Drawer } from '@mui/material';
import { useTranslation } from 'react-i18next';

import IconButton from 'components/Shared/Buttons/IconButton';
import closeButton from 'public/static/images/srp/Close_Mobile.svg';

import useOpenFilterModal from 'lib/hooks/useOpenFilterModal';

import { useMedia } from 'react-use';
import { BaseButton } from 'components/Shared/Buttons';
import { fonts } from 'components/styles/variables';
import SearchFilter from '../SearchFilter';
import { useStyles } from './styles';
import SaveClearSearchButtons from '../SearchFilter/SaveClearSearchButtons';

interface FiltersModalProps {
  onClick: () => void;
  isModalOpen: boolean;
  totalCount: number;
  searchVehicles: () => Promise<void>;
}

export default function FiltersModal({
  onClick,
  isModalOpen,
  totalCount,
  searchVehicles,
}: FiltersModalProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();

  const isTablet = useMedia(`(min-width: 600px)`);

  const { setOpenModalOnSignIn, savedSearchId } = useOpenFilterModal();

  function onSearchVehicles(): void {
    searchVehicles();
    onClick();
  }

  const totalResultsText =
    totalCount < 1000
      ? `${totalCount} ${t('srp.filters.results')}`
      : `1000+ ${t('srp.filters.results')}`;

  return (
    <>
      <Drawer classes={{ paper: classes.paper }} open={isModalOpen} anchor={'right'}>
        <div className={classes.paper}>
          <div className={classes.modalHeader}>
            <div className={classes.headerTopRow}>
              <div className={classes.headerTitle}>{t('srp.filters.modalHeader')}</div>
              <IconButton
                className="filters-modal-close-button"
                onClick={onClick}
                aria-label={t('accessibility.closeModal')}
                style={{
                  position: 'absolute',
                  top: '11px',
                  right: '5px',
                  backgroundPosition: 'center',
                  backgroundImage: `url(${closeButton})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '16px 16px',
                  padding: 0,
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'transparent',
                  borderStyle: 'none',
                }}
              />
            </div>
            <SaveClearSearchButtons
              mobileDrawer
              onClose={onClick}
              onSignedOutSaveSearch={(): void => setOpenModalOnSignIn(true)}
              savedSearchId={savedSearchId}
            />
          </div>
          <div className={classes.filtersListOuter}>
            <div className={classes.filtersList}>
              <SearchFilter hideOnMobile />
            </div>
          </div>

          <div className={classes.modalFooter}>
            <BaseButton
              onClick={isTablet ? onClick : onSearchVehicles}
              normalText={totalResultsText}
              style={{
                fontFamily: fonts.default,
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '0.2px',
                textTransform: 'none',
                width: 'calc(100% - 32px)',
                margin: '16px',
                borderRadius: '8px',
                height: '36px',
              }}
            />
          </div>
        </div>
      </Drawer>

      <style jsx>{`
        // disables scrolling of main page in mobile
        :global(html) {
          position: ${isModalOpen ? 'fixed' : undefined};
          width: ${isModalOpen ? '100%' : undefined};
        }
      `}</style>
    </>
  );
}
